import { render, staticRenderFns } from "./LotContent.vue?vue&type=template&id=db201f76&scoped=true"
import script from "./LotContent.vue?vue&type=script&lang=js"
export * from "./LotContent.vue?vue&type=script&lang=js"
import style0 from "./LotContent.vue?vue&type=style&index=0&id=db201f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db201f76",
  null
  
)

export default component.exports